/**
 * Spacing tokens
 */
export const spacing = {
  0: "0",
  1: "0.25rem",
  2: "0.5rem",
  3: "0.75rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  8: "2rem",
  10: "2.5rem",
  12: "3rem",
  16: "4rem",
  20: "5rem",
  21: "5.25rem",
  22: "5.5rem",
  23: "5.75rem",
  24: "6rem",
  25: "6.25rem",
  26: "6.5rem",
  27: "6.75rem",
  28: "7rem",
  29: "7.25rem",
  30: "7.5rem",
} as const;
